// REACT DEFAULTS
import { Link } from 'react-router-dom'

// STYLES & ASSETS
import styles from './Navbar.module.scss'
import logo from '../../assets/images/bani_logo_small.png'
import notification from '../../assets/images/icon_notification_alert.png'
import arrowDown from '../../assets/images/icon_arrow_down.png'

const Navbar = () => {
	return (
		<nav className={styles.navBar}>
			<Link to={'/'}>
				<img className={styles.logo} src={logo} alt="logo" />
			</Link>

			<div className={styles.links}>
				<Link to={'#'} className={styles.notificationWrapper}>
					<img
						className={styles.notification}
						src={notification}
						alt="notification"
					/>
				</Link>

				<div className={styles.userDetailsDiv}>
					<span className={styles.avatar}>JT</span>
					<div className={styles.userDetails}>
						<p className={styles.userName}>JT Industry Limit..</p>
						<small className={styles.userEmail}>JamesT@gmail.com</small>
					</div>
					<img className={styles.arrowDown} src={arrowDown} alt="arrowDown" />
				</div>
			</div>
		</nav>
	)
}

export default Navbar
